import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=41dcb210&scoped=true&"
import script from "./InfoComponent.vue?vue&type=script&lang=js&"
export * from "./InfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoComponent.vue?vue&type=style&index=0&id=41dcb210&prod&lang=css&"
import style1 from "./InfoComponent.vue?vue&type=style&index=1&id=41dcb210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcb210",
  null
  
)

export default component.exports